import {Component, OnInit} from '@angular/core';
import {MatDialogRef} from '@angular/material';
import {MainService} from '../../../main/main.service';
import {Observable, of} from 'rxjs/index';
import {FourDService, Project, TransformGroup} from '4d-mapper';
import {flatMap} from 'rxjs/operators';
import {Constants} from '../../Constants';

export interface Items {
  id: number;
  name: string;
}


@Component({
  selector: 'dialog-upload-to-project',
  templateUrl: './upload-to-project.component.html',
  styleUrls: ['./upload-to-project.component.scss']
})
export class UploadToProjectComponent  implements OnInit {

  debug:boolean = Constants.debug_off;

  addToExisting: any = 'existing';
  newOne = 'newOne';
  existing = 'existing';
  newProjectName = '';

  project: Project;
  scene: TransformGroup;

  projects : Project[] = [] ;

  scenes : TransformGroup[] = [] ;


  constructor(public dialogRef: MatDialogRef<UploadToProjectComponent> , public mainService: MainService,
              public fourD: FourDService) { }

  ngOnInit() {
    if ( this.debug ) { console.log ( 'upload-to-project.comp (loadProject)'); }
    this.loadProject().subscribe();
  }

  loadProject(): Observable<any> {
    if ( this.debug ) { console.log ( 'upload-to-project.comp loadProject()'); }
    if (!this.fourD.projects)
      return this.fourD.onReady().pipe(
        flatMap(p => this.fourD.setActiveTeam(p[0].uid)),
        flatMap(_ => this.loadProject())
      )
    this.projects = this.fourD.projects;
    return of('');
  }

  loadScene(){
    Constants.showHangOn();
    this.fourD.V.searchByObject(TransformGroup).equals('project' , this.project.id).queryObservable()     .subscribe(value => {
      this.scenes = value.items;
      Constants.hideHangOn();
    });
  }

  ok(){
    if(this.addToExisting === this.newOne){
      this.createNewProject();
    }else{
      this.dialogRef.close({
        project: this.project,
        scene: this.scene
      });
    }
  }

  private createNewProject() {
    Constants.showHangOn();
    var p = new Project(this.fourD.V)
    p.name = this.newProjectName
    p.account = this.fourD.activeTeam
    p['ignoreOrientation'] = true;
    p.saveObservable().subscribe(
      savedProject => {
        savedProject.groupList().subscribe(fetchedTGs => {
          if (fetchedTGs) {
            Constants.hideHangOn();
            this.mainService.newProjectCreatedSubject.next(savedProject);
            this.dialogRef.close({
              project: savedProject,
              scene: fetchedTGs[0]
            });
          }
        })
      }, error1 => {
        console.log(error1);
        Constants.hideHangOn();
      })
  }
}
